import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatTime(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function getTimerColor(seconds, warningThreshold = 300, criticalThreshold = 420) {
  if (seconds >= criticalThreshold) return 'critical';
  if (seconds >= warningThreshold) return 'warning';
  return 'neutral';
}

export function shouldFlash(seconds, criticalThreshold = 420) {
  return seconds >= criticalThreshold;
}